import React, { useState, useEffect, useImperativeHandle } from 'react';
import { MessageBox, Button, Table } from 'kenshin';
import { history, useSelector } from 'umi';
import TablePro from '@/components/TablePro';

const WorkDetailModal = ({ onCancel, visible, data = {}, ...props }) => {
  const projectDetailLogList = useSelector(
    ({ project }) => project.projectDetailLogList,
  );

  const rptAuditResultStatus = {
    1: <div className="status-green animate">通过</div>,
    2: <div className="status-red">驳回</div>,
  };

  const columns = [
    {
      dataIndex: 'empName',
      title: '员工姓名',
    },
    {
      dataIndex: 'deptList',
      title: '部门',
      render: (val) => val.map((item) => <div key={item}>{item}</div>),
    },
    {
      dataIndex: 'servCatgName',
      title: '工作包',
    },
    {
      dataIndex: 'rptDate',
      title: '上报日期',
      // render:val => moment(val).format("YYYY-MM-DD HH:mm:ss")
    },
    {
      dataIndex: 'rptRemark',
      title: '上报备注',
    },
    {
      dataIndex: 'rptWorkHours',
      title: '上报的标准工时',
    },
    {
      dataIndex: 'rptWorkOvertimeHours',
      title: '上报的加班工时',
    },
    {
      dataIndex: 'rptWorkTotalHours',
      title: '上报的总工时',
    },
    {
      dataIndex: 'rptAuditResult',
      title: '上报审核结果',
      render: (val) => rptAuditResultStatus[val],
    },
  ];

  return (
    <MessageBox
      title="工作包上报详情"
      width={1000}
      onCancel={onCancel}
      maskClosable={false}
      bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
      destroyOnClose
      visible={visible}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          关闭
        </Button>,
      ]}
      {...props}
    >
      <TablePro
        params={{
          projectId: data?.projectId,
          proServCatgId: data?.proServCatgId,
        }}
        request="project/projectDetailLog"
        rowKey="rptDetailId"
        columns={columns}
        curColumns
        columnsOptions={false}
        data={projectDetailLogList}
      />
    </MessageBox>
  );
};

export default WorkDetailModal;
